enum Resource {
	ENTRY = 'entry',
}

enum Triggers {
	ENTRY_SUBMITTED = 'entry_submitted',
	MANUAL_ON_DEMAND = 'manual_on_demand',
}

export { Resource, Triggers };
